<template>
  <div class="sn-f-b-s discharge-medicine">
    <sn-navigator id="CYDY"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s discharge-medicine-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_CYDY) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 discharge-medicine-blank">
        <!-- :class="{'sn-header-patient-special': selectedPatient.patientId}" -->
        <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>住院人：</div>
            </div>
            <div v-if="!$sn.validate.array(patientArray)" @click="handlePatientInfo();">
              暂未获取到住院人，<span class="sn-pointer sn-fc-main">点击刷新</span>
            </div>
            <div v-else-if="patientArray.length === 0" @click="navigateUrl('/patient/out/homepage');">
              暂无住院人，<span class="sn-pointer sn-fc-main">点击添加</span>
            </div>
            <template v-else>
              <el-select :value="selectedPatient.patientId" placeholder="请选择住院人" @change="changePatient">
                <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientArray"></el-option>
              </el-select>
            </template>
          </div>
          <template v-if="selectedPatient.patientId">
            <!-- <div class="sn-f-s-c region">
              <div class="sn-f-s-c patient-title">
                <div class="required">*</div>
                <div>{{ $sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL ? '证件号' : '就诊卡' }}：</div>
              </div>
              <div v-if="!outCardSerial" @click="navigateUrl('addition-card');">
                {{ outCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
              </div>
              <div v-else>
                <el-input readonly="readonly" v-model="outCardSerialFormat"></el-input>
              </div>
            </div> -->
            <div class="sn-f-s-c region">
              <div class="sn-f-s-c patient-title">
                <div class="required">*</div>
                <div>住院号：</div>
              </div>
              <div v-if="!inCardSerial" @click="navigateUrl('addition-card');">
                {{ inCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
              </div>
              <div v-else>
                <el-input readonly="readonly" v-model="inCardSerialFormat"></el-input>
              </div>
            </div>
            <div class="sn-f-s-c region">
              <div class="sn-f-s-c patient-title">
                <div class="required">*</div>
                <div>日期范围：</div>
              </div>
              <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="sn-f-s-c region">-</div>
            <div class="sn-f-s-c region">
              <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="sn-f-s-c region">
              <el-button type="primary" @click="searchBtn">查询</el-button>
            </div>
          </template>
        </div>
        <!-- <div class="sn-f-s-0 sn-f-e-c sn-header-patient" v-if="selectedPatient.patientId">
          <div class="sn-f-s-c region">
            <div class="sn-f-s-c patient-title">
              <div class="required">*</div>
              <div>日期范围：</div>
            </div>
            <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">-</div>
          <div class="sn-f-s-c region">
            <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
          <div class="sn-f-s-c region">
            <el-button type="primary" @click="searchBtn">查询</el-button>
          </div>
        </div> -->
        <template v-if="!$sn.validate.empty(handleDischargeMedicine)">
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>医生姓名</th>
                  <th>科室名称</th>
                  <th>入院日期</th>
                  <th>出院日期</th>
                  <th v-if="exist('openTime')">开立时间</th>
                  <th v-if="exist('pharmacist')">发药人</th>
                  <th v-if="exist('dispenser')">配药人</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="medicine.orderId" v-for="(medicine, index) in handleDischargeMedicine">
                  <td>{{ index + 1 }}</td>
                  <td>{{ medicine.doctorName }}</td>
                  <td>{{ medicine.deptName }}</td>
                  <td>{{ medicine.inDate }}</td>
                  <td>{{ medicine.outDate }}</td>
                  <td v-if="exist('openTime')">{{ medicine.openTime }}</td>
                  <td v-if="exist('pharmacist')">{{ medicine.pharmacist }}</td>
                  <td v-if="exist('dispenser')">{{ medicine.dispenser }}</td>
                  <td class="sn-pointer sn-fc-main" @click="navigateUrl('/query/discharge-medicine/detail', medicine);">查看详情</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
        <template v-else>
          <sn-no-data :message="noMessage"></sn-no-data>
          <!-- <div class="sn-f-c-c prompt-message">列表仅显示两个月内出院带药信息、更多记录请按时间筛选查询</div> -->
        </template>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(dischargeMedicineInfo, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
      <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
      <bind-card v-if="exhibitionBindCard" :patientId="selectedPatient.patientId || ''" :type="isOpenSingleCard ? '1' : bindCardType" @sendBack="sendBackBindCard"></bind-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import self from '@/common/utils/global-config';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';
import * as ServiceConfig from '@/common/utils/service-config';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  mixins: [PatientShareMixin],
  components: {
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  data() {
    return {
      dischargeMedicineArray: [],
      patientArray: [],
      selectedPatient: {},
      outCardSerial: '',
      outCardSerialFormat: '',
      inCardSerial: '',
      inCardSerialFormat: '',
      startDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd', self.$sn.getConfig('pcPrescriptionDateRange')[0], self.$sn.getConfig('pcPrescriptionDateRange')[1]), // 开始日期
      endDate: self.$sn.format.date(self.$sn.utils.getCurrentTime(), 'yyyy-MM-dd'), // 结束日期
      dischargeMedicineInfo: [],
      pageCount: 1,
      isResult: true,
      exhibitionCreatePatient: false,
      exhibitionBindCard: false,
      bindCardType: '2', // 1门诊 2住院
      noMessage: '暂无数据',
      isOpenSingleCard: self.$sn.getConfig('isOpenSingleCard')
    };
  },
  computed: {
    // 处理出院带药信息
    handleDischargeMedicine() {
      let handle = [];
      if (this.dischargeMedicineInfo.length > 0) handle = this.$sn.format.group(this.dischargeMedicineInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
      return handle;
    },
    exist() {
      return (key) => {
        let verify = false;
        if (this.dischargeMedicineInfo.length > 0) {
          if (!this.$sn.validate.empty(this.dischargeMedicineInfo.find(result => !this.$sn.validate.empty(result[key])))) {
            verify = true;
          }
        }
        return verify;
      };
    }
  },
  watch: {
    selectedPatient: async function(patient) {
      this.isResult = true;
      this.pageCount = 1;
      this.dischargeMedicineArray = [];
      this.dischargeMedicineInfo = [];
      this.noMessage = '暂未数据';
      if (patient.patientId) {
        const isOpenInModal = true;
        // const outHandle = await Tools.handlePatientInfo(patient);
        // if (outHandle.code >= 0) {
        //   this.outCardSerial = outHandle.data.no;
        //   this.outCardSerialFormat = outHandle.data.caption;
        //   if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && outHandle.code === 0) this.outCardSerialFormat = patient.idCardEncrypt;
        // }
        // if (!this.outCardSerial) {
        //   isOpenInModal = false;
        //   const compare = {
        //     [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
        //   };
        //   this.$sn.assembly.modal({
        //     caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
        //     success: (modal) => {
        //       if (modal.confirm) this.navigateUrl('addition-card');
        //     }
        //   });
        // }
        const intHandle = await Tools.handlePatientInfo(patient, '2');
        if (intHandle.code >= 0) {
          this.inCardSerial = intHandle.data.no;
          this.inCardSerialFormat = intHandle.data.caption;
          if (this.$sn.validate.empty(this.inCardSerial)) {
            this.noMessage = this.$sn.format.caption(Messages.SEARCH012, ['住院号']);
          }
          this.isResult = false;
        }
        if (this.inCardSerial) this.searchBtn();
        else {
          if (isOpenInModal) {
            this.$sn.assembly.modal({
              caption: this.$sn.format.caption(Messages.SEARCH002, ['住院号']),
              success: (modal) => {
                if (modal.confirm) {
                  this.navigateUrl('addition-card', {}, { type: '2' });
                }
              }
            });
          }
        }
      }
    },
    $route(val, old) {
      if ((old.path === '/query/discharge-medicine' && val.path !== '/query/discharge-medicine/detail') || (old.path === '/query/discharge-medicine/detail' && val.path !== '/query/discharge-medicine')) {
        this.initialDischargeMedicine();
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.dischargeMedicineInfo, this.perpetual.PAGINATION_SIZE)[n])) {
          this.paginateResult();
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.initialDischargeMedicine();
  },
  methods: {
    // 初始化出院带药
    initialDischargeMedicine() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_CYDY);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_CYDY);
      this.handlePatientInfo();
    },
    // 处理就诊人信息
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      if (this.$sn.utils.getHospitalLocalStorage('Login_PatientList')) {
        if (this.isOpenSingleCard) this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
        else this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
      }
      if (this.patientArray && this.patientArray.length > 0) {
        if (this.isOpenSingleCard) this.selectedPatient = this.$sn.utils.getCurrentPatient() || this.patientArray[0];
        else this.selectedPatient = this.patientArray.find(item => item.inCardNo) || this.patientArray[0];
      }
    },
    // 切换就诊人
    changePatient(id) {
      if (id) {
        this.selectedPatient = this.patientArray.find(item => item.patientId === id);
        // this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    // 添加就诊人回调
    sendBackCreatePatient(type) {
      if (type) {
        if (this.$sn.utils.getHospitalLocalStorage('Login_PatientList')) {
          this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
        }
      }
      this.exhibitionCreatePatient = false;
    },
    // 绑卡回调
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        if (this.$sn.utils.getHospitalLocalStorage('Login_PatientList')) {
          this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList').filter(item => item.inCardNo);
        }
      }
      this.exhibitionBindCard = false;
    },
    // 查询处方
    searchBtn() {
      // if (this.$sn.validate.empty(this.outCardSerial)) {
      //   const compare = {
      //     [this.perpetual.HOSPITAL_ID_SDSL]: 'PATIENT043'
      //   };
      //   this.$sn.assembly.modal({
      //     caption: Messages[compare[this.$sn.utils.getHospitalId()] || 'RECHARGE012'],
      //     success: (modal) => {
      //       if (modal.confirm) this.navigateUrl('addition-card');
      //     }
      //   });
      // }
      if (this.$sn.validate.empty(this.inCardSerial)) {
        // this.$sn.assembly.modal({
        //   caption: this.$sn.format.caption(Messages.SEARCH002, ['住院号']),
        //   success: (modal) => {
        //     if (modal.confirm) {
        //       this.navigateUrl('addition-card', {}, { type: '2' });
        //     }
        //   }
        // });
        return false;
      }
      else {
        if (this.$sn.validate.empty(this.startDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['开始日期']));
          return false;
        }
        if (this.$sn.validate.empty(this.endDate)) {
          this.getShowToast(this.$sn.format.caption(Messages.SEARCH011, ['结束日期']));
          return false;
        }
        const start = new Date(this.startDate).getTime();
        const end = new Date(this.endDate).getTime();
        if (end < start) {
          this.getShowToast('结束日期不能早于开始日期');
          return false;
        }
        const code = {
          [this.perpetual.HOSPITAL_ID_LCRM]: '1088c8a2-dff6-4736-ac32-e9464682a90c',
          [this.perpetual.HOSPITAL_ID_JNYZ]: '3f0f51f77ad1454286b8b3879625fea1',
          [this.perpetual.HOSPITAL_ID_SDSZL]: 'e9d1190f-e0f5-8253-5793-50234bdd7c5a'
        };
        const xml = {
          PlatformId: this.$sn.utils.getPlatformType(),
          PlatformUserId: this.$sn.utils.getOpenId(),
          PatId: this.selectedPatient.patientId,
          CardNo: this.outCardSerial,
          FunctionType: '2',
          StartDate: this.startDate,
          EndDate: this.endDate,
          hosArea: ''
        };
        const params = {
          url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
          method: 'POST',
          header: true,
          data: this.$sn.utils.variableEncryption(this.$sn.format.xml(xml))
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
          this.$sn.assembly.loading(false);
          this.isResult = true;
          if (result && result.code === 0 && result.data) {
            if (result.data.ResultCode === '0') {
              this.dischargeMedicineArray = result.data.Data;
              this.paginateResult();
            }
            else this.getShowToast(result.data.ResultMsg);
          }
          else {
            this.getShowToast(result?.msg || Messages.C001);
          }
        });
      }
    },
    // 分页
    paginateResult() {
      const start = (this.pageCount - 1) * this.perpetual.PAGINATION_SIZE;
      const end = this.pageCount * this.perpetual.PAGINATION_SIZE;
      if (this.isResult) this.dischargeMedicineInfo = this.dischargeMedicineArray;
      if (this.dischargeMedicineArray.slice(start, end).length < this.perpetual.PAGINATION_SIZE) this.isResult = false;
      if (this.dischargeMedicineArray.slice(start, end).length === 0) this.isResult = false;
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.dischargeMedicineInfo, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    // 跳转页面
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/query/discharge-medicine/detail' && !this.$sn.validate.empty(item)) {
        this.$sn.utils.setHospitalSessionStorage('Discharge_Medicine_Info', {
          ...item,
          inCardNo: this.inCardSerial
        });
      }
      if (url === 'addition-patient') this.exhibitionCreatePatient = true;
      else if (url === 'addition-card') this.exhibitionBindCard = true;
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {
    if (this.$sn.utils.getHospitalSessionStorage('Discharge_Medicine_Info')) {
      this.$sn.utils.removeHospitalSessionStorage('Discharge_Medicine_Info');
    }
  }
};
</script>
<style lang="scss" scoped>
.discharge-medicine {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .discharge-medicine-blank {
      overflow: hidden;
      width: 100%;
      padding-right: 20px;
      display: flex;
      flex-direction: column;

      ::v-deep .sn-header-patient {
        .el-date-editor.el-input {
          width: 130px;
        }

        .el-input--suffix .el-input__inner {
          padding-right: 0;
        }

        &-special {
          justify-content: flex-start;
          border: none;
          margin: 0;
          height: 50px;
        }
      }

      .el-button {
        padding: 10px 20px;
        background-color: $main1;
        border-color: $main1;
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
